import React, { forwardRef, HTMLAttributes } from "react";

export const SR = forwardRef<HTMLSpanElement, HTMLAttributes<HTMLSpanElement>>(
  ({ children, className = "" }, ref) => (
    <span className={`sr-only ${className}`} ref={ref}>
      {children}
    </span>
  )
);